import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Inject static SEO block before React root for /ua pages
// This ensures crawlers see real HTML content in the DOM before JS rendering
const isUaPage = window.location.pathname.startsWith('/ua');
const rootEl = document.getElementById('root');
if (isUaPage && rootEl && !document.getElementById('ua-seo-static')) {
  const seoBlock = document.createElement('section');
  seoBlock.id = 'ua-seo-static';
  seoBlock.setAttribute('style', 'padding:24px 16px; max-width:980px; margin:0 auto;');
  seoBlock.innerHTML = `
    <h1>Український стоматолог у Лондоні (Angel, Islington) — Dentico Clinic</h1>
    <p><strong>Dentico Clinic</strong> — сучасна приватна стоматологія в центрі Лондона (Angel / Islington, EC1V).
    Якщо ви шукаєте <strong>українського стоматолога в Лондоні</strong>, у нас доступна консультація та лікування <strong>українською мовою</strong>.</p>
    <h2>Адреса та контакти</h2>
    <p><strong>360–364 City Road, London EC1V 2PY</strong> (поруч з Angel Station)<br>
    Тел: <a href="tel:+447345197820">+44 7345 197820</a> ·
    Email: <a href="mailto:info@denticoclinic.co.uk">info@denticoclinic.co.uk</a></p>
    <h2>Послуги</h2>
    <ul>
      <li>Професійна гігієна та чистка зубів</li>
      <li>Лікування карієсу та пломби</li>
      <li>Лікування каналів (ендодонтія)</li>
      <li>Коронки та протезування</li>
      <li>Вініри (естетична стоматологія)</li>
      <li>Імплантація зубів</li>
      <li>Невідкладна стоматологічна допомога</li>
    </ul>
    <h2>FAQ</h2>
    <p><strong>Чи є український стоматолог у Лондоні?</strong><br>Так, у Dentico Clinic можливе спілкування українською мовою.</p>
    <p><strong>Де ви знаходитесь?</strong><br>360–364 City Road, London EC1V 2PY, поруч з Angel Station.</p>
    <p><strong>Як записатися?</strong><br>Запис онлайн або через WhatsApp/Telegram, також доступний запис телефоном.</p>
  `;
  // Insert before #root so it appears first in the DOM
  rootEl.parentNode?.insertBefore(seoBlock, rootEl);
  // Hide it once React renders (so it doesn't show duplicate content visually)
  // The block stays in DOM for crawlers but won't be visible to users
  const hideAfterRender = () => {
    seoBlock.style.position = 'absolute';
    seoBlock.style.width = '1px';
    seoBlock.style.height = '1px';
    seoBlock.style.overflow = 'hidden';
    seoBlock.style.clip = 'rect(0,0,0,0)';
    seoBlock.style.whiteSpace = 'nowrap';
  };
  // Hide after a short delay to let crawlers capture the visible content
  requestAnimationFrame(hideAfterRender);
}
render(<App data-id="element-292" />, document.getElementById('root'));